/*
fields = [
  {
    "uuid": "f7cbe308-e0dd-4287-852b-9f516f59d729",
    "key": "f7cbe308-e0dd-4287-852b-9f516f59d729",
    "name": "Karakteristik Kepadatan Pengembangan",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "8b61921e-226e-4837-a772-2b9544bec1af",
    "key": "8b61921e-226e-4837-a772-2b9544bec1af",
    "name": "Issue Lingkungan",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1",
    "key": "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1",
    "name": "Catatan Issue Lingkungan",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "7041488d-69e3-430b-af1e-10042d5ac235",
    "key": "7041488d-69e3-430b-af1e-10042d5ac235",
    "name": "Analisis Risiko",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "9426feab-7cdc-4bd5-a06a-551f6516b680",
    "key": "9426feab-7cdc-4bd5-a06a-551f6516b680",
    "name": "Tipe Properti",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "f19d5369-ec97-47cc-af3b-c6241d94e8bf",
    "key": "f19d5369-ec97-47cc-af3b-c6241d94e8bf",
    "name": "Aksesibilitas",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39",
    "key": "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39",
    "name": "Data Jalan: Jumlah Jalur",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "89d7dbf5-a674-4893-8603-26d11fbba1d5",
    "key": "89d7dbf5-a674-4893-8603-26d11fbba1d5",
    "name": "Data Jalan: Lebar Jalan",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "6d9eca1e-6d9f-4e40-97b9-952665d097da",
    "key": "6d9eca1e-6d9f-4e40-97b9-952665d097da",
    "name": "Data Jalan: Kondisi Fisik",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "f314fe82-da32-4a28-8eb2-979651e6c003",
    "key": "f314fe82-da32-4a28-8eb2-979651e6c003",
    "name": "Data Jalan: Intensitas Lalulintas",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e",
    "key": "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e",
    "name": "Karakteristik Ekonomi: Harga Sewa/Tahun",
    "type": "number",
    "isHighlight": true
  },
  {
    "uuid": "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5",
    "key": "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5",
    "name": "Luas Tanah (m2)",
    "type": "number",
    "isHighlight": true
  },
  {
    "uuid": "cd66cd38-6f8d-4016-b8aa-014c556c98e2",
    "key": "cd66cd38-6f8d-4016-b8aa-014c556c98e2",
    "name": "Bentuk Tanah",
    "type": "text",
    "isHighlight": true
  },
  {
    "uuid": "5f1c5705-3f91-441e-ba05-a50be1f9e027",
    "key": "5f1c5705-3f91-441e-ba05-a50be1f9e027",
    "name": "Luas Bagunan Sesuai Fisik (m2)",
    "type": "number",
    "isHighlight": true
  }
]

*/

/*
poi_survey_1_features = [
  {
    "_id": "6715a9e05eadfd017995b7c4",
    "type": "Feature",
    "geometry": {
      "coordinates": [110.418750117469, -6.97499245443786, 0],
      "type": "Point"
    },
    "properties": {
      "f7cbe308-e0dd-4287-852b-9f516f59d729": "Padat",
      "8b61921e-226e-4837-a772-2b9544bec1af": "Bunyi",
      "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1": "Padatnya lalu lintas di depan area properti 24 jam sehingga bunyinya sangat mengganggu, terutama di malam hari",
      "7041488d-69e3-430b-af1e-10042d5ac235": "Banjir",
      "9426feab-7cdc-4bd5-a06a-551f6516b680": "Retail mini market",
      "f19d5369-ec97-47cc-af3b-c6241d94e8bf": "Jalan kolektor",
      "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39": 2,
      "89d7dbf5-a674-4893-8603-26d11fbba1d5": "10",
      "6d9eca1e-6d9f-4e40-97b9-952665d097da": "Baik",
      "f314fe82-da32-4a28-8eb2-979651e6c003": "Tinggi",
      "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e": 210000000,
      "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5": "823.2",
      "cd66cd38-6f8d-4016-b8aa-014c556c98e2": "bujur sangkat",
      "5f1c5705-3f91-441e-ba05-a50be1f9e027": "397.5"
    }
  },
  {
    "_id": "6715a9e05eadfd017995b807",
    "type": "Feature",
    "geometry": {
      "coordinates": [110.431201578676, -6.97761244042934, 0],
      "type": "Point"
    },
    "properties": {
      "f7cbe308-e0dd-4287-852b-9f516f59d729": "Padat",
      "8b61921e-226e-4837-a772-2b9544bec1af": "Bunyi",
      "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1": "dekat dengan jalan raya yang ramai",
      "7041488d-69e3-430b-af1e-10042d5ac235": "Banjir",
      "9426feab-7cdc-4bd5-a06a-551f6516b680": "ruko",
      "f19d5369-ec97-47cc-af3b-c6241d94e8bf": "mobil dan motor",
      "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39": 1,
      "89d7dbf5-a674-4893-8603-26d11fbba1d5": "4",
      "6d9eca1e-6d9f-4e40-97b9-952665d097da": "Baik",
      "f314fe82-da32-4a28-8eb2-979651e6c003": "Tinggi",
      "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e": 120000000,
      "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5": "80",
      "cd66cd38-6f8d-4016-b8aa-014c556c98e2": "persegi panjang",
      "5f1c5705-3f91-441e-ba05-a50be1f9e027": "80"
    }
  },
  {
    "_id": "6715a9e05eadfd017995b806",
    "type": "Feature",
    "geometry": {
      "coordinates": [110.431152392756, -6.97753884110654, 0],
      "type": "Point"
    },
    "properties": {
      "f7cbe308-e0dd-4287-852b-9f516f59d729": "Padat",
      "8b61921e-226e-4837-a772-2b9544bec1af": "Bunyi",
      "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1": "dekat dengan jalan raya",
      "7041488d-69e3-430b-af1e-10042d5ac235": "Banjir",
      "9426feab-7cdc-4bd5-a06a-551f6516b680": "ruko",
      "f19d5369-ec97-47cc-af3b-c6241d94e8bf": "mobil dan motor",
      "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39": 1,
      "89d7dbf5-a674-4893-8603-26d11fbba1d5": "4",
      "6d9eca1e-6d9f-4e40-97b9-952665d097da": "Baik",
      "f314fe82-da32-4a28-8eb2-979651e6c003": "Tinggi",
      "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e": 120000000,
      "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5": "80",
      "cd66cd38-6f8d-4016-b8aa-014c556c98e2": "persegi",
      "5f1c5705-3f91-441e-ba05-a50be1f9e027": "60"
    }
  },
  {
    "_id": "6715a9e05eadfd017995b803",
    "type": "Feature",
    "geometry": {
      "coordinates": [110.431389124251, -6.97839898816096, 0],
      "type": "Point"
    },
    "properties": {
      "f7cbe308-e0dd-4287-852b-9f516f59d729": "Padat",
      "8b61921e-226e-4837-a772-2b9544bec1af": "Bunyi",
      "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1": "dekat dengan jalan raya",
      "7041488d-69e3-430b-af1e-10042d5ac235": "Banjir",
      "9426feab-7cdc-4bd5-a06a-551f6516b680": "ruko",
      "f19d5369-ec97-47cc-af3b-c6241d94e8bf": "motor dan mobil",
      "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39": 1,
      "89d7dbf5-a674-4893-8603-26d11fbba1d5": "4",
      "6d9eca1e-6d9f-4e40-97b9-952665d097da": "Baik",
      "f314fe82-da32-4a28-8eb2-979651e6c003": "Tinggi",
      "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e": 150000000,
      "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5": "60",
      "cd66cd38-6f8d-4016-b8aa-014c556c98e2": "persegi panjang",
      "5f1c5705-3f91-441e-ba05-a50be1f9e027": "60"
    }
  },
  {
    "_id": "6715a9e05eadfd017995b804",
    "type": "Feature",
    "geometry": {
      "coordinates": [110.431387839889, -6.97828391448574, 0],
      "type": "Point"
    },
    "properties": {
      "f7cbe308-e0dd-4287-852b-9f516f59d729": "Padat",
      "8b61921e-226e-4837-a772-2b9544bec1af": "Bunyi",
      "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1": "dekat dengan jalan raya",
      "7041488d-69e3-430b-af1e-10042d5ac235": "Banjir",
      "9426feab-7cdc-4bd5-a06a-551f6516b680": "ruko",
      "f19d5369-ec97-47cc-af3b-c6241d94e8bf": "motor dan mobil",
      "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39": 1,
      "89d7dbf5-a674-4893-8603-26d11fbba1d5": "4",
      "6d9eca1e-6d9f-4e40-97b9-952665d097da": "Baik",
      "f314fe82-da32-4a28-8eb2-979651e6c003": "Tinggi",
      "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e": 75000000,
      "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5": "60",
      "cd66cd38-6f8d-4016-b8aa-014c556c98e2": "persegi panjang",
      "5f1c5705-3f91-441e-ba05-a50be1f9e027": "60"
    }
  },
  {
    "_id": "6715a9e05eadfd017995b805",
    "type": "Feature",
    "geometry": {
      "coordinates": [110.431391273968, -6.97805230373095, 0],
      "type": "Point"
    },
    "properties": {
      "f7cbe308-e0dd-4287-852b-9f516f59d729": "Padat",
      "8b61921e-226e-4837-a772-2b9544bec1af": "Bunyi",
      "2704f5a2-f9ca-4f57-bdc6-ffee1acdbab1": "dekat dengan jalan raya",
      "7041488d-69e3-430b-af1e-10042d5ac235": "Banjir",
      "9426feab-7cdc-4bd5-a06a-551f6516b680": "ruko",
      "f19d5369-ec97-47cc-af3b-c6241d94e8bf": "motor mobil",
      "3f1f44ec-18e9-41bd-9d03-af8e1dd7da39": 1,
      "89d7dbf5-a674-4893-8603-26d11fbba1d5": "4",
      "6d9eca1e-6d9f-4e40-97b9-952665d097da": "Baik",
      "f314fe82-da32-4a28-8eb2-979651e6c003": "Tinggi",
      "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e": 150000000,
      "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5": "80",
      "cd66cd38-6f8d-4016-b8aa-014c556c98e2": "persegi",
      "5f1c5705-3f91-441e-ba05-a50be1f9e027": "80"
    }
  }
]

*/

import { useMemo, useState, useEffect } from "react";
import { connect } from "react-redux";
import Modal from "../common_modal/Modal";

// --- KONSTANTA FIELD UUID ---
const FIELD_UUID_RENT_PRICE = "adaa7d32-31b9-4da8-a4c5-0a59c8b1642e";
const FIELD_UUID_LAND_AREA = "f0db8d9e-68b9-4acb-8c52-1a5f35c8faf5";
const FIELD_UUID_LAND_SHAPE = "cd66cd38-6f8d-4016-b8aa-014c556c98e2";
const FIELD_UUID_BUILDING_AREA = "5f1c5705-3f91-441e-ba05-a50be1f9e027";
const FIELD_UUID_RISK_ANALYSIS = "7041488d-69e3-430b-af1e-10042d5ac235";
const FIELD_UUID_ENV_ISSUE = "8b61921e-226e-4837-a772-2b9544bec1af";

// --- KONSTANTA BISNIS ---
const CONSTRUCTION_COST_PER_M2 = 4500000;
const MAX_DISTANCE_KM = 5;
const WEIGHT_ATTRIBUTE = 0.7;
const WEIGHT_DISTANCE = 0.3;

const YIELD_OPTIONS = [
  { label: "Konservatif (Yield 3%)", value: 0.03 },
  { label: "Moderat (Yield 5%)", value: 0.05 },
  { label: "Agresif (Yield 7%)", value: 0.07 },
];

// --- HELPER FORMAT ---
const format_idr = (val) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(val);

// const format_decimal = (val) =>
//   new Intl.NumberFormat("id-ID", {
//     maximumFractionDigits: 2,
//   }).format(val);

// --- KOMPONEN KECIL ---
const CopyButton = ({ value }) => {
  const [copied, set_copied] = useState(false);

  const handle_copy = () => {
    if (!value) return;
    navigator.clipboard.writeText(Math.round(value).toString());
    set_copied(true);
    setTimeout(() => set_copied(false), 2000);
  };

  return (
    <button
      className={`button_small ${
        copied ? "green_container" : "background_grey outline_black"
      }`}
      onClick={handle_copy}
      style={{ marginLeft: "10px", cursor: "pointer" }}
      title="Copy Raw Number"
    >
      {copied ? "Tersalin!" : "Copy"}
    </button>
  );
};

const SINI_APPRAISAL_TOOL = ({ auth, sini }) => {
  const { sini_v2_list, request_id_active, ai_parent_detail_list } = sini;

  // --- STATE ---
  const [user_inputs, set_user_inputs] = useState({});
  const [land_dims, set_land_dims] = useState({ length: "", width: "" });
  const [selected_yield, set_selected_yield] = useState(0.05);

  const [appraisal_result, set_appraisal_result] = useState(null);
  const [risk_summary, set_risk_summary] = useState(null);
  const [characteristic_summary, set_characteristic_summary] = useState([]);
  const [processed_comparables, set_processed_comparables] = useState([]);

  // State baru untuk menyimpan nilai intermediet perhitungan
  const [calculation_breakdown, set_calculation_breakdown] = useState(null);
  const [modal_explanation, set_modal_explanation] = useState(false);

  const toggle_explanation = () => set_modal_explanation(!modal_explanation);

  // --- PREPARING DATA ---
  const { fields, poi_survey_1_features, user_lat, user_long } = useMemo(() => {
    const merge_array = [...sini_v2_list, ...ai_parent_detail_list];
    const sini_object = merge_array.find(
      (item) => item.request_id === request_id_active
    );

    const lat = sini_object?.lat ? parseFloat(sini_object.lat) : 0;
    const long = sini_object?.long ? parseFloat(sini_object.long) : 0;
    const poi_raw = sini_object?.poi_survey_1_features || [];
    const fields_list = (sini_object?.manifest_survey_1?.fields || [])
      .filter((f) => f.isHighlight)
      .map((f) => ({
        uuid: f.uuid,
        key: f.key,
        name: f.name,
        type: f.type,
      }));

    const highlightKeys = fields_list.map((f) => f.key);
    const poi_list = poi_raw.map((feature) => {
      const filtered = {};
      highlightKeys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(feature.properties, key)) {
          filtered[key] = feature.properties[key];
        }
      });
      return { ...feature, properties: filtered };
    });

    return {
      fields: fields_list,
      poi_survey_1_features: poi_list,
      user_lat: lat,
      user_long: long,
    };
  }, [sini_v2_list, ai_parent_detail_list, request_id_active]);

  useEffect(() => {
    if (
      poi_survey_1_features.length > 0 &&
      processed_comparables.length === 0
    ) {
      set_processed_comparables(
        poi_survey_1_features.map((f) => ({
          ...f,
          similarity_total: 0,
          scores: { distance_km: 0 },
        }))
      );
    }
  }, [poi_survey_1_features, processed_comparables.length]);

  // --- LOGIKA INPUT DIMENSI ---
  useEffect(() => {
    const l = parseFloat(land_dims.length) || 0;
    const w = parseFloat(land_dims.width) || 0;
    if (l > 0 && w > 0) {
      const area = l * w;
      const ratio = Math.abs(l - w) / Math.max(l, w);
      set_user_inputs((prev) => ({
        ...prev,
        [FIELD_UUID_LAND_AREA]: area.toString(),
        [FIELD_UUID_LAND_SHAPE]: ratio < 0.1 ? "Persegi" : "Persegi Panjang",
      }));
    }
  }, [land_dims]);

  const handle_input_change = (key, val) => {
    set_user_inputs((prev) => ({ ...prev, [key]: val }));
  };

  // --- HELPER CALCULATIONS ---
  const calculate_haversine = (lat1, lon1, lat2, lon2) => {
    if (!lat1 || !lon1 || !lat2 || !lon2) return 0;
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const get_most_frequent = (arr) => {
    if (arr.length === 0) return "-";
    const hash = {};
    let max_el = arr[0],
      max_count = 1;
    for (let i = 0; i < arr.length; i++) {
      let el = arr[i];
      if (hash[el] == null) hash[el] = 1;
      else hash[el]++;
      if (hash[el] > max_count) {
        max_el = el;
        max_count = hash[el];
      }
    }
    return max_el;
  };

  // --- INTI ALGORITMA APPRAISAL ---
  const run_appraisal = () => {
    if (!user_lat || !user_long) return alert("Lokasi User Invalid");

    // 1. Filter Data Valid
    const valid_comps = poi_survey_1_features.filter((f) => {
      const price = parseFloat(f.properties[FIELD_UUID_RENT_PRICE]);
      return !isNaN(price) && price > 0;
    });

    if (valid_comps.length === 0)
      return alert("Tidak ada data pembanding valid.");

    // 2. Scoring Mechanism
    const scored_comps = valid_comps.map((f) => {
      let attr_score_sum = 0,
        attr_count = 0;

      fields.forEach((field) => {
        if (field.key === FIELD_UUID_RENT_PRICE) return;
        const u_val = user_inputs[field.key];
        const f_val = f.properties[field.key];

        if (u_val && f_val) {
          const u_num = parseFloat(u_val);
          const f_num = parseFloat(f_val);
          if (!isNaN(u_num) && !isNaN(f_num)) {
            const max = Math.max(u_num, f_num);
            const score = max === 0 ? 0 : 1 - Math.abs(u_num - f_num) / max;
            attr_score_sum += score > 0 ? score : 0;
          } else {
            if (String(u_val).toLowerCase() === String(f_val).toLowerCase()) {
              attr_score_sum += 1;
            }
          }
          attr_count++;
        }
      });

      const final_attr = attr_count === 0 ? 0 : attr_score_sum / attr_count;

      const dist = calculate_haversine(
        user_lat,
        user_long,
        f.geometry.coordinates[1],
        f.geometry.coordinates[0]
      );
      let dist_score = 1 - dist / MAX_DISTANCE_KM;
      if (dist_score < 0) dist_score = 0;

      return {
        ...f,
        similarity_total:
          final_attr * WEIGHT_ATTRIBUTE + dist_score * WEIGHT_DISTANCE,
        scores: {
          attribute: final_attr,
          distance: dist_score,
          distance_km: dist,
        },
        price_per_m2:
          parseFloat(f.properties[FIELD_UUID_RENT_PRICE]) /
          (parseFloat(f.properties[FIELD_UUID_BUILDING_AREA]) || 1),
      };
    });

    // Sort by Similarity
    const sorted_comps = [...scored_comps].sort(
      (a, b) => b.similarity_total - a.similarity_total
    );
    set_processed_comparables(sorted_comps);

    // 3. Kalkulasi 3 Alternatif
    const top_3 = sorted_comps.slice(0, 3);
    const top_n_display = sorted_comps.slice(0, 5); // Untuk tabel breakdown

    // A. Moderat (Weighted Average)
    let sum_weighted_price = 0;
    let sum_weights = 0;

    // Menyimpan breakdown moderat
    const moderate_components = [];

    sorted_comps.forEach((c) => {
      const weight = c.similarity_total;
      const price = c.price_per_m2;
      const weighted_p = price * weight;

      sum_weighted_price += weighted_p;
      sum_weights += weight;

      // Simpan top 5 kontributor untuk display
      if (moderate_components.length < 5) {
        moderate_components.push({
          score: weight,
          price: price,
          result: weighted_p,
        });
      }
    });

    const price_m2_moderate =
      sum_weights > 0 ? sum_weighted_price / sum_weights : 0;

    // B. Konservatif & C. Agresif
    // Cari min dan max dari top 3 untuk tracking
    let min_price_obj = top_3[0];
    let max_price_obj = top_3[0];

    top_3.forEach((c) => {
      if (c.price_per_m2 < min_price_obj.price_per_m2) min_price_obj = c;
      if (c.price_per_m2 > max_price_obj.price_per_m2) max_price_obj = c;
    });

    const price_m2_conservative = min_price_obj.price_per_m2;
    const price_m2_aggressive = max_price_obj.price_per_m2;

    // User Data
    const u_build_area = parseFloat(user_inputs[FIELD_UUID_BUILDING_AREA]) || 0;
    const u_land_area = parseFloat(user_inputs[FIELD_UUID_LAND_AREA]) || 0;

    // Build Result Object
    const build_result = (price_per_m2) => {
      const rent_year = price_per_m2 * u_build_area;
      const house_price = rent_year / selected_yield;
      const land_val = house_price - u_build_area * CONSTRUCTION_COST_PER_M2;
      return {
        rent_year,
        house_price,
        land_val: land_val > 0 ? land_val : 0,
        land_m2:
          u_land_area > 0 ? (land_val > 0 ? land_val : 0) / u_land_area : 0,
      };
    };

    set_appraisal_result({
      conservative: build_result(price_m2_conservative),
      moderate: build_result(price_m2_moderate),
      aggressive: build_result(price_m2_aggressive),
    });

    // 4. Analisis Karakteristik (Summaries)
    const char_summary = [];
    fields.forEach((field) => {
      if (
        field.type === "text" &&
        field.key !== FIELD_UUID_RISK_ANALYSIS &&
        field.key !== FIELD_UUID_ENV_ISSUE
      ) {
        const values = top_n_display
          .map((c) => c.properties[field.key])
          .filter((v) => v);
        const mode = get_most_frequent(values);
        if (mode !== "-") {
          char_summary.push({ name: field.name, value: mode });
        }
      }
    });
    set_characteristic_summary(char_summary);

    const risks = new Set();
    top_3.forEach((c) => {
      if (c.properties[FIELD_UUID_RISK_ANALYSIS])
        risks.add(c.properties[FIELD_UUID_RISK_ANALYSIS]);
      if (c.properties[FIELD_UUID_ENV_ISSUE])
        risks.add(c.properties[FIELD_UUID_ENV_ISSUE]);
    });
    set_risk_summary(
      Array.from(risks).join(", ") ||
        "Minim risiko terdeteksi pada pembanding terdekat."
    );

    // 5. SIMPAN STEP-BY-STEP BREAKDOWN
    set_calculation_breakdown({
      user_params: {
        build_area: u_build_area,
        land_area: u_land_area,
        yield_percent: selected_yield,
        construction_cost: CONSTRUCTION_COST_PER_M2,
      },
      comparables_metrics: {
        top_3: top_3.map((c) => ({
          score: c.similarity_total,
          price: c.price_per_m2,
          dist: c.scores.distance_km,
        })),
        min_obj: {
          price: price_m2_conservative,
          score: min_price_obj.similarity_total,
        },
        max_obj: {
          price: price_m2_aggressive,
          score: max_price_obj.similarity_total,
        },
      },
      moderate_math: {
        numerator: sum_weighted_price,
        denominator: sum_weights,
        final_price: price_m2_moderate,
        components: moderate_components,
      },
    });
  };

  return (
    <main className="two_container_equal max_height">
      {/* --- MODAL PENJELASAN STEP BY STEP --- */}
      {modal_explanation && calculation_breakdown && (
        <Modal
          modalSize="medium"
          isOpen={modal_explanation}
          onClose={toggle_explanation}
          title="Detail Perhitungan Appraisal"
        >
          <div className="box-body">
            {/* BAGIAN 1: RUMUS DASAR */}

            <div className="container background_white outline_grey margin_bottom">
              <h3 className="text_bold margin_bottom_small">
                1. Prinsip Dasar
              </h3>
              <p className="text_medium">
                Perhitungan menggunakan metode{" "}
                <strong>Sales Comparison Approach</strong> yang dikombinasikan
                dengan{" "}
                <strong>Income Approach (Kapitalisasi Pendapatan)</strong>.
              </p>
              <hr className="margin_top_small margin_bottom_small" />
              <ul style={{ paddingLeft: "20px" }}>
                <li>
                  <strong>Unit Price Sewa (Rp/m²)</strong> didapat dari data
                  pembanding.
                </li>
                <li>
                  <strong>Nilai Properti</strong> = Sewa Tahunan / Yield (Cap
                  Rate).
                </li>
                <li>
                  <strong>Nilai Tanah</strong> = Nilai Properti - Biaya
                  Konstruksi Bangunan.
                </li>
              </ul>
            </div>

            {/* BAGIAN 2: PENENTUAN UNIT PRICE */}

            {/* MODERAT DETAIL */}
            <div className="container background_white outline_grey margin_bottom">
              <h3 className="text_bold margin_bottom_small">
                2. Penentuan Harga Sewa/m²
              </h3>

              <table style={{ tableLayout: "fixed", width: "100%" }}>
                <tbody>
                  {/* Added verticalAlign: "top" here */}
                  <tr style={{ verticalAlign: "top" }}>
                    <td>
                      <div className="container background_white outline_grey">
                        <p className="badge green_container text_bold margin_bottom_small">
                          Skenario Moderat (Weighted Average)
                        </p>
                        <p className="text_small sub_color margin_bottom">
                          Setiap data pembanding diberi bobot berdasarkan
                          tingkat kemiripannya (Skor Similarity). Semakin mirip,
                          semakin besar pengaruhnya terhadap harga.
                        </p>
                        <div className="container background_grey_light margin_bottom">
                          <p className="text_small text_center">
                            Sampel Perhitungan (Top 5 Paling Mirip)
                          </p>
                          <table className="table">
                            <thead>
                              <tr>
                                <th>Harga (Rp/m²) [A]</th>
                                <th>Skor [B]</th>
                                <th>Hasil [A x B]</th>
                              </tr>
                            </thead>
                            <tbody>
                              {calculation_breakdown.moderate_math.components.map(
                                (row, idx) => (
                                  <tr key={idx}>
                                    <td>{format_idr(row.price)}</td>
                                    <td>{(row.score * 100).toFixed(1)}%</td>
                                    <td>{format_idr(row.result)}</td>
                                  </tr>
                                )
                              )}
                              <tr>
                                <td
                                  colSpan="3"
                                  className="text_center text_italic sub_color"
                                >
                                  ...dst (Total {processed_comparables.length}{" "}
                                  data)
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="text_center">
                          <p className="text_bold">Rumus:</p>
                          <p className="text_medium">
                            <span className="text_bold">
                              {format_idr(
                                calculation_breakdown.moderate_math.numerator
                              )}
                            </span>{" "}
                            (Total Weighted Price) <br />
                            --------------------------------------------------{" "}
                            <br />
                            <span className="text_bold">
                              {calculation_breakdown.moderate_math.denominator.toFixed(
                                4
                              )}
                            </span>{" "}
                            (Total Skor)
                          </p>
                          <p className="text_bold margin_top_small">
                            ={" "}
                            {format_idr(
                              calculation_breakdown.moderate_math.final_price
                            )}{" "}
                            / m²
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="container background_white outline_grey">
                        <p className="badge grey_container text_bold margin_bottom_small">
                          Konservatif
                        </p>
                        <p className="text_small sub_color margin_bottom">
                          Mengambil <strong>harga terendah</strong> dari Top 3
                          data termirip untuk meminimalisir risiko (Risk
                          Averse).
                        </p>
                        <p className="text_medium text_center background_grey padding_small">
                          Min(Top 3) ={" "}
                          <strong>
                            {format_idr(
                              calculation_breakdown.comparables_metrics.min_obj
                                .price
                            )}
                          </strong>
                          /m²
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="container background_white outline_grey">
                        <p className="badge yellow_container text_bold margin_bottom_small">
                          Agresif
                        </p>
                        <p className="text_small sub_color margin_bottom">
                          Mengambil <strong>harga tertinggi</strong> dari Top 3
                          data termirip (Optimistic View).
                        </p>
                        <p className="text_medium text_center background_grey padding_small">
                          Max(Top 3) ={" "}
                          <strong>
                            {format_idr(
                              calculation_breakdown.comparables_metrics.max_obj
                                .price
                            )}
                          </strong>
                          /m²
                        </p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* BAGIAN 3: KONVERSI NILAI */}

            <div className="container background_white outline_grey margin_bottom">
              <h3 className="text_bold margin_bottom_small">
                3. Konversi ke Nilai Jual (Valuation)
              </h3>
              <p className="text_small sub_color margin_bottom">
                Contoh perhitungan menggunakan angka <strong>Moderat</strong>:
              </p>
              <div
                className="row margin_bottom_small"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>A. Harga Sewa/m²</span>
                <span className="text_bold">
                  {format_idr(calculation_breakdown.moderate_math.final_price)}
                </span>
              </div>
              <div
                className="row margin_bottom_small"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>B. Luas Bangunan Subjek</span>
                <span className="text_bold">
                  {calculation_breakdown.user_params.build_area} m²
                </span>
              </div>
              <div
                className="row margin_bottom"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "5px",
                }}
              >
                <span>C. Potensi Sewa Tahunan (A x B)</span>
                <span className="text_bold">
                  {format_idr(
                    calculation_breakdown.moderate_math.final_price *
                      calculation_breakdown.user_params.build_area
                  )}
                </span>
              </div>

              <div
                className="row margin_bottom_small"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>D. Yield (Cap Rate)</span>
                <span className="text_bold">
                  {calculation_breakdown.user_params.yield_percent * 100}%
                </span>
              </div>
              <div
                className="row margin_bottom"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #ccc",
                  paddingBottom: "5px",
                }}
              >
                <span>E. Estimasi Harga Properti (C / D)</span>
                <span className="text_bold">
                  {format_idr(
                    (calculation_breakdown.moderate_math.final_price *
                      calculation_breakdown.user_params.build_area) /
                      calculation_breakdown.user_params.yield_percent
                  )}
                </span>
              </div>

              <div
                className="row margin_bottom_small"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <span>
                  F. Biaya Depresiasi Bangunan (
                  {format_idr(
                    calculation_breakdown.user_params.construction_cost
                  )}
                  /m²)
                </span>
                <span className="text_bold red_color">
                  -{" "}
                  {format_idr(
                    calculation_breakdown.user_params.construction_cost *
                      calculation_breakdown.user_params.build_area
                  )}
                </span>
              </div>
              <div
                className="row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#e6f4ea",
                  padding: "10px",
                  borderRadius: "4px",
                }}
              >
                <span className="text_bold">
                  G. Estimasi Nilai Tanah (E - F)
                </span>
                <span className="text_bold green_color">
                  {format_idr(
                    (calculation_breakdown.moderate_math.final_price *
                      calculation_breakdown.user_params.build_area) /
                      calculation_breakdown.user_params.yield_percent -
                      calculation_breakdown.user_params.construction_cost *
                        calculation_breakdown.user_params.build_area
                  )}
                </span>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {/* --- KIRI: INPUT FORM --- */}
      <section className="container background_white outline_grey">
        <p className="text_center text_bold margin_bottom">
          Parameter Properti Subjek
        </p>

        {/* Input Dimensi */}
        <div className="two_container_equal margin_bottom">
          <div>
            <label className="text_medium">Panjang (m)</label>
            <input
              type="number"
              className="margin_bottom"
              value={land_dims.length}
              onChange={(e) =>
                set_land_dims({ ...land_dims, length: e.target.value })
              }
              placeholder="0"
            />
            <label className="text_medium">Lebar (m)</label>
            <input
              type="number"
              value={land_dims.width}
              onChange={(e) =>
                set_land_dims({ ...land_dims, width: e.target.value })
              }
              placeholder="0"
            />
          </div>
          <div>
            <label className="text_medium">Luas Tanah (Calculated)</label>
            <input
              readOnly
              className="margin_bottom background_grey"
              value={user_inputs[FIELD_UUID_LAND_AREA] || 0}
            />
            <label className="text_medium">Bentuk Tanah</label>
            <input
              readOnly
              className="background_grey"
              value={user_inputs[FIELD_UUID_LAND_SHAPE] || "-"}
            />
          </div>
        </div>

        {/* Dynamic Fields Input */}
        <div className="margin_bottom">
          {fields
            .filter((f) => f.key === FIELD_UUID_BUILDING_AREA)
            .map((f) => (
              <div key={f.uuid}>
                <label className="text_medium">{f.name}</label>
                <input
                  type="number"
                  className="margin_bottom"
                  value={user_inputs[f.key] || ""}
                  onChange={(e) => handle_input_change(f.key, e.target.value)}
                  placeholder="Masukkan luas..."
                />
              </div>
            ))}
          <label className="text_medium">Skenario Yield (Cap Rate)</label>
          <select
            className="full_width"
            value={selected_yield}
            onChange={(e) => set_selected_yield(parseFloat(e.target.value))}
          >
            {YIELD_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>

        <button
          className="button_big background_black full_width margin_top"
          onClick={run_appraisal}
        >
          HITUNG ESTIMASI HARGA
        </button>

        {/* --- HASIL APPRAISAL --- */}
        {appraisal_result && (
          <div className="margin_top_big">
            <hr className="margin_bottom" />

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="margin_bottom"
            >
              <p className="text_bold">Hasil Analisis</p>
              <button
                onClick={toggle_explanation}
                className="button_small button_white outline_black text_small"
              >
                Lihat Cara Hitung
              </button>
            </div>

            {/* 1. Konservatif */}
            <div className="container background_grey_light margin_bottom outline_grey">
              <p className="text_bold sub_color">
                Opsi 1: Konservatif (Minimum)
              </p>
              <div className="two_container_equal">
                <h2 className="text_bold">
                  {format_idr(appraisal_result.conservative.rent_year)} /tahun
                </h2>
                <div className="text_right">
                  <CopyButton value={appraisal_result.conservative.rent_year} />
                </div>
              </div>
              <p className="text_small">
                Estimasi Jual:{" "}
                {format_idr(appraisal_result.conservative.house_price)}
              </p>
            </div>

            {/* 2. Moderat */}
            <div className="container green_container margin_bottom outline_grey">
              <p className="text_bold sub_color">
                Opsi 2: Moderat (Recommended)
              </p>
              <div className="two_container_equal">
                <h2 className="text_bold">
                  {format_idr(appraisal_result.moderate.rent_year)} /tahun
                </h2>
                <div className="text_right">
                  <CopyButton value={appraisal_result.moderate.rent_year} />
                </div>
              </div>
              <p className="text_small">
                Estimasi Jual:{" "}
                {format_idr(appraisal_result.moderate.house_price)}
              </p>
            </div>

            {/* 3. Agresif */}
            <div className="container yellow_container margin_bottom outline_grey">
              <p className="text_bold sub_color">Opsi 3: Agresif (Maksimum)</p>
              <div className="two_container_equal">
                <h2 className="text_bold">
                  {format_idr(appraisal_result.aggressive.rent_year)} /tahun
                </h2>
                <div className="text_right">
                  <CopyButton value={appraisal_result.aggressive.rent_year} />
                </div>
              </div>
              <p className="text_small">
                Estimasi Jual:{" "}
                {format_idr(appraisal_result.aggressive.house_price)}
              </p>
            </div>

            {/* Rangkuman Karakteristik & Risiko */}
            <div className="container background_white outline_grey margin_top">
              <p className="text_bold text_small margin_bottom">
                KARAKTERISTIK DOMINAN AREA:
              </p>
              <div className="text_medium sub_color margin_bottom">
                <ul style={{ paddingLeft: "20px", columns: 2 }}>
                  {characteristic_summary.map((char, idx) => (
                    <li key={idx} className="margin_bottom_small">
                      <strong>{char.name}:</strong> {char.value}
                    </li>
                  ))}
                </ul>
              </div>
              <hr className="margin_bottom" />
              <p className="text_bold text_small red_color">POTENSI RISIKO:</p>
              <p className="text_medium">{risk_summary}</p>
            </div>
          </div>
        )}
      </section>

      {/* --- KANAN: TABEL DATA --- */}
      <section className="container background_white outline_grey">
        <h3 className="text_center text_bold margin_bottom">
          Analisis Data Pembanding
        </h3>
        <div style={{ overflow: "auto", maxHeight: "calc(100vh - 150px)" }}>
          <table className="table full_width">
            <thead>
              <tr>
                <th className="text_center">Skor</th>
                {fields.map((f, i) => (
                  <th key={i}>{f.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {processed_comparables.map((item, idx) => {
                const score = Math.round(item.similarity_total * 100);
                const badge =
                  score > 80
                    ? "green_container"
                    : score > 50
                    ? "yellow_container"
                    : "grey_container";
                return (
                  <tr key={idx}>
                    <td className="text_center">
                      <span className={`badge ${badge}`}>{score}%</span>
                      <div className="text_small margin_top_small">
                        {item.scores.distance_km.toFixed(2)} km
                      </div>
                    </td>
                    {fields.map((f, fIdx) => (
                      <td key={fIdx}>
                        {f.type === "number"
                          ? new Intl.NumberFormat("id-ID").format(
                              item.properties[f.key]
                            )
                          : item.properties[f.key]}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  sini: state.sini,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(SINI_APPRAISAL_TOOL);
